// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import PropTypes from "prop-types";

import { Link } from "@/components/core";

export function NavbarButton({ href, sx, onClick, children }: any) {
  return (
    <Link
      color="inherit"
      variant="outlined"
      onClick={onClick}
      sx={{
        border: "1px solid",
        borderRadius: 2,
        borderWidth: 2,
        background: "inherit",
        fontWeight: "700",
        px: 2,
        py: 2,
        ...sx,
      }}
      href={href}
    >
      {children}
    </Link>
  );
}

NavbarButton.propTypes = {
  href: PropTypes.string,
  sx: PropTypes.object,
  onClick: PropTypes.func,
  children: PropTypes.node,
};
